<a href="/wishlist" class="wishlisticon"><i class="fa fa-sharp fa-regular fa-heart wishicon"  aria-hidden="true"></i></a>